// External Packages
import { useState, useContext } from "react";

// Internal Packages
import { DataContext } from "../../context/data-context";

// External Components
import {
  BsPlusLg,
  BsArrowLeftSquare,
  BsArrowRightSquare,
  BsFilter,
} from "react-icons/bs";
import { MdRefresh } from "react-icons/md";

// Internal Components
import CustomerCard from "./CustomerCard";
import LoadingSpinnerWrapper from "../UI/LoadingSpinnerWrapper";
import SearchBar from "../UI/SearchBar";
import Heading from "../UI/Heading";
import { arrayToCsv } from "../../util/arrayToCsv";
import { BiDownload } from "react-icons/bi";
import FilterMenu from "../UI/FilterMenu";

/*
  * All Customers Page
  This page displays all customers in the database.
*/

export default function CustomersPage() {
  const { customers, loadingData, fetchCustomers } = useContext(DataContext);
  const [filteredCustomers, setFilteredCustomers] = useState(customers);

  // ========================================================== SEARCH CUSTOMERS
  const searchUsers = (query) => {
    setFilteredCustomers(
      customers.filter((customer) =>
        `${customer.firstName} ${customer.lastName}
        ${customer.email} ${customer.phone} ${customer.drivers_license_number}`
          .toLowerCase()
          .includes(query.toLowerCase())
      )
    );
  };

  // ========================================================== FILTER HANDLER
  const filterOptions = [
    { label: "Location", options: ["All", "Boston, MA", "Dallas, TX"] },
    { label: "Booking", options: ["All", "Booked", "Not Booked"] },
    { label: "Plan", options: ["All", "LUXURY", "PLUSH", "POSH"] },
  ];
  const filterHandler = (filters) => {
    const filtered = [];
    customers.forEach((customer) => {
      let filter = true;
      if (
        filters.location !== "All" &&
        customer.state?.toUpperCase() !==
          filters.location.split(",")[1].trim().toUpperCase()
      )
        filter = false;
      if (filters.bo === "Booked" && !customer.booking) filter = false;
      if (filters.booking === "Not Booked" && customer.booking) filter = false;
      if (filters.plan !== "All" && customer.plan?.name !== filters.plan)
        filter = false;
      if (filter) filtered.push(customer);
    });
    setFilteredCustomers(filtered);
  };

  // ========================================================== DOWNLOAD CSV
  const downloadCSV = () => {
    const filtered = [];
    customers.forEach((customer) => {
      if (customer.drivers_license_front) {
        filtered.push(customer);
      }
    });
    arrayToCsv(filtered);
  };

  return (
    <div className="container grid">
      <Heading title="Customers">
        <FilterMenu onSubmit={filterHandler} options={filterOptions}>
          <BsFilter className="text-2xl text-white cursor-pointer hover:text-stone-400" />
        </FilterMenu>
        <BsPlusLg className="text-lg text-white cursor-pointer hover:text-stone-400" />
        <MdRefresh
          onClick={fetchCustomers}
          className="text-2xl text-white cursor-pointer hover:text-stone-400"
        />
        <BiDownload
          onClick={downloadCSV}
          className="text-2xl text-white cursor-pointer hover:text-stone-400"
        />
      </Heading>

      <SearchBar
        searchHandler={searchUsers}
        clearSearch={() => setFilteredCustomers(customers)}
      />

      <div className="list">
        {loadingData ? (
          <LoadingSpinnerWrapper />
        ) : (
          <div className="grid gap-8">
            {filteredCustomers.map((customer) => (
              <CustomerCard customer={customer} key={customer.id} />
            ))}
          </div>
        )}
      </div>

      <div className="flex items-center justify-end space-x-4 text-sm text-stone-200">
        <p className="text-stone-400">
          Showing {filteredCustomers.length} of {filteredCustomers.length}{" "}
        </p>
        <BsArrowLeftSquare className="inline-block text-xl" />
        <BsArrowRightSquare className="inline-block text-xl" />
      </div>
    </div>
  );
}
